export default {
  SET_IS_SHOWN: (state, boolean) => { state.isShown = boolean; },
  SET_PAYMENT_METHOD_LIST: (state, value) => { state.paymentMethodsList = value; },
};
